(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.closest(".mega-sticky-header")?.classList.add("disclosure__list_overlay");
      this.closest(".header__mobile-menu")?.classList.add("disclosure__list_overlay");
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      this.closest(".mega-sticky-header")?.classList.remove("disclosure__list_overlay");
      this.closest(".header__mobile-menu")?.classList.remove("disclosure__list_overlay");
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const fetchMetafieldVisibility = async (productLink) => {
    try {
      const productUrl = new URL(productLink, window.location.origin);
      productUrl.searchParams.set('view', 'metafield-check');
      const response = await fetch(productUrl.href);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      return data.hide_from_search === true;
    } catch (error) {
      console.error(`Error checking metafield for ${productLink}:`, error);
      return false;
    }
  };

  const filterHiddenRecommendationProducts = async (recommendationsRoot) => {
    const recommendationsList = recommendationsRoot.querySelector('ul.grid');
    if (!recommendationsList) return;

    const productItems = Array.from(recommendationsList.querySelectorAll('li.grid__item'));
    if (!productItems.length) return;

    const maxItemsAttr = recommendationsRoot.dataset.limit;
    const maxVisibleItems = parseInt(maxItemsAttr, 10) || productItems.length;

    const visibilityChecks = productItems.map(async (item) => {
      const productAnchor = item.querySelector('a');
      if (!productAnchor) return { item, hide: false };

      const shouldHide = await fetchMetafieldVisibility(productAnchor.getAttribute('href'));
      return { item, hide: shouldHide };
    });

    const results = await Promise.all(visibilityChecks);

    recommendationsList.innerHTML = '';
    const visibleItems = results.filter(({ hide }) => !hide).map(({ item }) => item);
    visibleItems.slice(0, maxVisibleItems).forEach(item => {
      recommendationsList.appendChild(item);
    });

    if (!recommendationsList.children.length) {
      recommendationsRoot.innerHTML = '';
    }
  };

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(async text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations) {
              await filterHiddenRecommendationProducts(recommendations);
              this.innerHTML = recommendations.innerHTML;
            }

            if (this.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            } else {
              this.classList.remove('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
